import React, { useState } from 'react';


// TODO: Replace these placeholders with your actual links
// Build APP_LINK using current domain and query string
const APP_LINK = window.location.origin + window.location.pathname + window.location.search;

// Helper to parse query string
function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

const APP_STORE_ID = getQueryParam('isi');
const PLAY_STORE_ID = getQueryParam('apn');
const APP_STORE_LINK = APP_STORE_ID ? `https://apps.apple.com/app/id${APP_STORE_ID}` : 'https://apps.apple.com/';
const PLAY_STORE_LINK = PLAY_STORE_ID ? `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}` : 'https://play.google.com/store';



const Redirect = () => {
  const [showButton, setShowButton] = useState(false);

  React.useEffect(() => {
    const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    let storeUrl = '';
    if (isAndroid) {
      storeUrl = PLAY_STORE_ID ? PLAY_STORE_LINK : '';
    } else if (isIOS) {
      storeUrl = APP_STORE_ID ? APP_STORE_LINK : '';
    }

    let hidden, visibilityChange;
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden'; visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden'; visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden'; visibilityChange = 'webkitvisibilitychange';
    }

    let didHide = false;
    const onVisibilityChange = () => {
      if (document[hidden]) {
        didHide = true;
      }
    };
    document.addEventListener(visibilityChange, onVisibilityChange);

    // Try to open the app
    // window.location.href = APP_LINK;

    setTimeout(() => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
      if (!didHide) {
        // App not opened, redirect to store (only if storeUrl exists)
        if (storeUrl) {
          window.location.href = storeUrl;
          setTimeout(() => setShowButton(true), 2000);
        } else {
          setShowButton(false);
        }
      }
    }, 1500);
    // eslint-disable-next-line
  }, []);

  const checkAndRedirect = () => {
    setShowButton(false);
    // Retry the same logic as above
    const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    let storeUrl = '';
    if (isAndroid) {
      storeUrl = PLAY_STORE_LINK;
    } else if (isIOS) {
      storeUrl = APP_STORE_LINK;
    }

    let hidden, visibilityChange;
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden'; visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden'; visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden'; visibilityChange = 'webkitvisibilitychange';
    }

    let didHide = false;
    const onVisibilityChange = () => {
      if (document[hidden]) {
        didHide = true;
      }
    };
    document.addEventListener(visibilityChange, onVisibilityChange);

    window.location.href = APP_LINK;

    setTimeout(() => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
      if (!didHide) {
        window.location.href = storeUrl;
        setTimeout(() => setShowButton(true), 2000);
      }
    }, 1500);
  };

  return (
    <div style={{ textAlign: 'center', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginTop: '15vh' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '70px' }}>
        <img src={process.env.PUBLIC_URL + '/logo.png'} alt="OptiSigns Logo" style={{ height: '128px', marginBottom: '0px' }} />
        {showButton ? (
          <button
            style={{
              padding: '12px 32px',
              fontSize: '1.2rem',
              borderRadius: '8px',
              border: 'none',
              background: '#1976d2',
              color: '#fff',
              cursor: 'pointer',
              marginTop: '0px',
            }}
            onClick={checkAndRedirect}
          >
            Open App
          </button>
        ) : (
          <>
            <div style={{ marginTop: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <div className="loader" style={{ width: '24px', height: '24px', border: '1.5px solid #1976d2', borderTop: '1.5px solid #fff', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: '0px' }}></div>
            </div>
            <style>
              {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
            </style>
          </>
        )}
      </div>
    </div>
  );
};

export default Redirect;
